export default __webpack_public_path__ + "static/bg1-0a9a028310a2b35eacef5204274c766d.jpg";